module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "frontmatter",
      "title": "Contents"
    }
  }, [_c('h2', {
    staticClass: "fmt"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_v",
      "title": "v"
    }
  }, [_vm._v("CONTENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_fm"
  }, [_c('a', {
    attrs: {
      "href": "#/text/v1_E_Preface#ri1",
      "id": "i1"
    }
  }, [_c('i', [_vm._v("Editor")]), _vm._v("’"), _c('i', [_vm._v("s Preface")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_fm"
  }, [_c('a', {
    attrs: {
      "href": "#/text/v1_A_Preface#ri2",
      "id": "i2"
    }
  }, [_c('i', [_vm._v("Author")]), _vm._v("’"), _c('i', [_vm._v("s Preface")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_h1"
  }, [_c('a', {
    attrs: {
      "href": "#/text/v1_Introduction#ri3",
      "id": "i3"
    }
  }, [_vm._v("INTRODUCTION")])]), _vm._v(" "), _c('p', {
    staticClass: "tocsub"
  }, [_c('a', {
    attrs: {
      "href": "#/text/v1_Introduction#ri4",
      "id": "i4"
    }
  }, [_vm._v("The Author")])]), _vm._v(" "), _c('p', {
    staticClass: "tocsub"
  }, [_c('a', {
    attrs: {
      "href": "#/text/v1_Introduction#ri5",
      "id": "i5"
    }
  }, [_vm._v("The Occasion")])]), _vm._v(" "), _c('p', {
    staticClass: "tocsub"
  }, [_c('a', {
    attrs: {
      "href": "#/text/v1_Introduction#ri6",
      "id": "i6"
    }
  }, [_vm._v("The Church at Rome")])]), _vm._v(" "), _c('p', {
    staticClass: "tocsub"
  }, [_c('a', {
    attrs: {
      "href": "#/text/v1_Introduction#ri7",
      "id": "i7"
    }
  }, [_vm._v("Summary of Contents")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_h1"
  }, [_c('a', {
    attrs: {
      "href": "#/text/v1_Chapter01#ri8"
    }
  }, [_vm._v("TEXT, EXPOSITION AND NOTES")])]), _vm._v(" "), _c('p', {
    staticClass: "tocsub"
  }, [_c('a', {
    attrs: {
      "href": "#/text/v1_Chapter01#ri8",
      "id": "i8"
    }
  }, [_vm._v("R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OMANS")]), _vm._v(" I")])]), _vm._v(" "), _c('p', {
    staticClass: "tocr1"
  }, [_c('a', {
    attrs: {
      "href": "#/text/v1_Chapter01#ri9",
      "id": "i9"
    }
  }, [_vm._v("I."), _c('span', {
    staticClass: "trp"
  }, [_vm._v("Salutation")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocr2"
  }, [_c('a', {
    attrs: {
      "href": "#/text/v1_Chapter02#ri10",
      "id": "i10"
    }
  }, [_vm._v("II."), _c('span', {
    staticClass: "trp"
  }, [_vm._v("Introduction")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocr3"
  }, [_c('a', {
    attrs: {
      "href": "#/text/v1_Chapter03#ri11",
      "id": "i11"
    }
  }, [_vm._v("III."), _c('span', {
    staticClass: "trp"
  }, [_vm._v("Theme of the Epistle")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocr4"
  }, [_c('a', {
    attrs: {
      "href": "#/text/v1_Chapter04#ri12",
      "id": "i12"
    }
  }, [_vm._v("IV."), _c('span', {
    staticClass: "trp"
  }, [_vm._v("The Universality of Sin and Condemnation")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocra"
  }, [_c('a', {
    attrs: {
      "href": "#/text/v1_Chapter04#ri13",
      "id": "i13"
    }
  }, [_vm._v("A."), _c('span', {
    staticClass: "trp"
  }, [_vm._v("The Gentiles")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocsub"
  }, [_c('a', {
    attrs: {
      "href": "#/text/v1_Chapter05#ri14",
      "id": "i14"
    }
  }, [_vm._v("R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OMANS")]), _vm._v(" II")])]), _vm._v(" "), _c('p', {
    staticClass: "tocra"
  }, [_c('a', {
    attrs: {
      "href": "#/text/v1_Chapter05#ri15",
      "id": "i15"
    }
  }, [_vm._v("B."), _c('span', {
    staticClass: "trp"
  }, [_vm._v("The Jews")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocra"
  }, [_c('span', {
    attrs: {
      "href": "#/text/v1_Chapter06#ri16",
      "id": "i16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("C."), _c('span', {
    staticClass: "trp"
  }, [_vm._v("The Aggravation of the Jew’s Condemnation")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocsub"
  }, [_c('span', {
    attrs: {
      "href": "#/text/v1_Chapter07#ri17",
      "id": "i17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OMANS")]), _vm._v(" III")])]), _vm._v(" "), _c('p', {
    staticClass: "tocra"
  }, [_c('span', {
    attrs: {
      "href": "#/text/v1_Chapter07#ri18",
      "id": "i18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("D."), _c('span', {
    staticClass: "trp"
  }, [_vm._v("The Faithfulness and Justice of God")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocra"
  }, [_c('span', {
    attrs: {
      "href": "#/text/v1_Chapter08#ri19",
      "id": "i19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("E."), _c('span', {
    staticClass: "trp"
  }, [_vm._v("Conclusion")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocr5"
  }, [_c('span', {
    attrs: {
      "href": "#/text/v1_Chapter09#ri20",
      "id": "i20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("V."), _c('span', {
    staticClass: "trp"
  }, [_vm._v("The Righteousness of God")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocsub"
  }, [_c('span', {
    attrs: {
      "href": "#/text/v1_Chapter10#ri21",
      "id": "i21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OMANS")]), _vm._v(" IV")])]), _vm._v(" "), _c('p', {
    staticClass: "tocr6"
  }, [_c('span', {
    attrs: {
      "href": "#/text/v1_Chapter10#ri22",
      "id": "i22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VI."), _c('span', {
    staticClass: "trp"
  }, [_vm._v("Corroboration from the Old Testament")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocsub"
  }, [_c('span', {
    attrs: {
      "href": "#/text/v1_Chapter11#ri23",
      "id": "i23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OMANS")]), _vm._v(" V")])]), _vm._v(" "), _c('p', {
    staticClass: "tocr7"
  }, [_c('span', {
    attrs: {
      "href": "#/text/v1_Chapter11#ri24",
      "id": "i24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VII."), _c('span', {
    staticClass: "trp"
  }, [_vm._v("Fruits of Justification")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocr8"
  }, [_c('span', {
    attrs: {
      "href": "#/text/v1_Chapter12#ri25",
      "id": "i25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VIII."), _c('span', {
    staticClass: "trp"
  }, [_vm._v("The Analogy")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocsub"
  }, [_c('span', {
    attrs: {
      "href": "#/text/v1_Chapter13#ri26",
      "id": "i26",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_vi",
      "title": "vi"
    }
  }, [_vm._v("R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OMANS")]), _vm._v(" VI")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocr9"
  }, [_c('span', {
    attrs: {
      "href": "#/text/v1_Chapter13#ri27",
      "id": "i27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IX."), _c('span', {
    staticClass: "trp"
  }, [_vm._v("The Sanctifying Effects")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocra"
  }, [_c('span', {
    attrs: {
      "href": "#/text/v1_Chapter13#ri28",
      "id": "i28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A."), _c('span', {
    staticClass: "trp"
  }, [_vm._v("The Abuse of Grace Exposed")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocra"
  }, [_c('span', {
    attrs: {
      "href": "#/text/v1_Chapter13#ri29",
      "id": "i29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("B."), _c('span', {
    staticClass: "trp"
  }, [_vm._v("The Imperatives for the Sanctified")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocsub"
  }, [_c('span', {
    attrs: {
      "href": "#/text/v1_Chapter14#ri30",
      "id": "i30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OMANS")]), _vm._v(" VII")])]), _vm._v(" "), _c('p', {
    staticClass: "tocr10"
  }, [_c('span', {
    attrs: {
      "href": "#/text/v1_Chapter14#ri31",
      "id": "i31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("X."), _c('span', {
    staticClass: "trp"
  }, [_vm._v("Death to the Law")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocr11"
  }, [_c('span', {
    attrs: {
      "href": "#/text/v1_Chapter15#ri32",
      "id": "i32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XI."), _c('span', {
    staticClass: "trp"
  }, [_vm._v("Transitional Experience")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocr12"
  }, [_c('span', {
    attrs: {
      "href": "#/text/v1_Chapter16#ri33",
      "id": "i33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XII."), _c('span', {
    staticClass: "trp"
  }, [_vm._v("The Contradiction in the Believer")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocsub"
  }, [_c('span', {
    attrs: {
      "href": "#/text/v1_Chapter17#ri34",
      "id": "i34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OMANS")]), _vm._v(" VIII")])]), _vm._v(" "), _c('p', {
    staticClass: "tocr13"
  }, [_c('span', {
    attrs: {
      "href": "#/text/v1_Chapter17#ri35",
      "id": "i35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XIII."), _c('span', {
    staticClass: "trp"
  }, [_vm._v("Life in the Spirit")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc_h1s"
  }, [_c('span', {
    attrs: {
      "href": "#/text/v1_Chapter18#ri36",
      "id": "i36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("PPENDIX")]), _vm._v(" A: Justification")])]), _vm._v(" "), _c('p', {
    staticClass: "tocsub"
  }, [_c('span', {
    attrs: {
      "href": "#/text/v1_Chapter18#ri37",
      "id": "i37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Old Testament")])]), _vm._v(" "), _c('p', {
    staticClass: "tocr1"
  }, [_c('span', {
    attrs: {
      "href": "#/text/v1_Chapter18#ri38",
      "id": "i38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I."), _c('span', {
    staticClass: "trp"
  }, [_vm._v("The Usage")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocra1"
  }, [_c('span', {
    attrs: {
      "href": "#/text/v1_Chapter18#ri39",
      "id": "i39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1."), _c('span', {
    staticClass: "trp"
  }, [_vm._v("Stative")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocra1"
  }, [_c('span', {
    attrs: {
      "href": "#/text/v1_Chapter18#ri40",
      "id": "i40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2."), _c('span', {
    staticClass: "trp"
  }, [_vm._v("Causative")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocra1"
  }, [_c('span', {
    attrs: {
      "href": "#/text/v1_Chapter18#ri41",
      "id": "i41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3."), _c('span', {
    staticClass: "trp"
  }, [_vm._v("Demonstrative")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocra1"
  }, [_c('span', {
    attrs: {
      "href": "#/text/v1_Chapter18#ri42",
      "id": "i42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4."), _c('span', {
    staticClass: "trp"
  }, [_vm._v("Forensic")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocr2"
  }, [_c('span', {
    attrs: {
      "href": "#/text/v1_Chapter18#ri43",
      "id": "i43",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II."), _c('span', {
    staticClass: "trp"
  }, [_vm._v("God’s Justification of Men")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocsub"
  }, [_c('span', {
    attrs: {
      "href": "#/text/v1_Chapter18#ri44",
      "id": "i44",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The New Testament")])]), _vm._v(" "), _c('p', {
    staticClass: "tocr1"
  }, [_c('span', {
    attrs: {
      "href": "#/text/v1_Chapter18#ri45",
      "id": "i45",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I."), _c('span', {
    staticClass: "trp"
  }, [_vm._v("The Terms")])])]), _vm._v(" "), _c('p', {
    staticClass: "tocr2"
  }, [_c('span', {
    attrs: {
      "href": "#/text/v1_Chapter18#ri46",
      "id": "i46",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II."), _c('span', {
    staticClass: "trp"
  }, [_vm._v("The Righteousness Contemplated")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-l"
  }, [_c('span', {
    attrs: {
      "href": "#/text/v1_Chapter18#ri47",
      "id": "i47",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Romish Doctrine of Justification")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_h1s"
  }, [_c('span', {
    attrs: {
      "href": "#/text/v1_Chapter19#ri48",
      "id": "i48",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("PPENDIX")]), _vm._v(" B: From Faith to Faith")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_h1s"
  }, [_c('span', {
    attrs: {
      "href": "#/text/v1_Chapter20#ri49",
      "id": "i49",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("PPENDIX")]), _vm._v(" C: Isaiah 53:11")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_h1s"
  }, [_c('span', {
    attrs: {
      "href": "#/text/v1_Chapter21#ri50",
      "id": "i50",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("PPENDIX")]), _vm._v(" D: Karl Barth on Romans 5")])]), _vm._v(" "), _c('p', {
    staticClass: "toc_h1s"
  }, [_c('span', {
    attrs: {
      "href": "#/text/v1_Index1#ri51",
      "id": "i51",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("NDEXES")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0a3c1122","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/v1_Contents.vue
// module id = 69
// module chunks = 0